import type { RouteRecordNormalized } from 'vue-router';
import { AppRouteRecordRaw } from './types';
import SYSTEM from './modules/system';
import USER from './modules/user';
import MEMBER from './modules/member';
import STATION from './modules/station';
import DASHBOARD from './modules/dashboard';
import VISUALIZATION from './modules/visualization';
import LIST from './modules/list';
import FORM from './modules/form';
import PROFILE from './modules/profile';
import RESULT from './modules/result';
import EXCEPTION from './modules/exception';
import CHARGING from './modules/charging';
import PARTNER from './modules/partner';
import MARKETING from './modules/marketing';
import ORDER from './modules/order';
import PROFIT from './modules/profit';
import BILLING from './modules/billing';
import OCCUPANCY_FEE from './modules/occupancy-fee';
import HOMEPAGE from './modules/homePage';
import MEMBERCARD from './modules/memberCard';
import INVOICE from './modules/invoice';
import STATISTIC from './modules/statistic';
import THIRD_PARTY from './modules/third-party';
import PARKING_WAIVER from './modules/parking-waiver';
import BARRIER_DEVICE from './modules/barrier-device';
import PAYMENT from './modules/payment';
import INVESTOR from './modules/investor';
import PARTNER_SETTLEMENT from './modules/partner-settlement';
import CAR from './modules/car';
import FORWARD from './modules/forward';
import MONITOR_SCREEN from './modules/monitor-screen';
import PUBLIC_QRCODE from './modules/public-qrcode';

const externalModules = import.meta.glob('./externalModules/*.ts', {
  eager: true,
});

function formatModules(_modules: any, result: RouteRecordNormalized[]) {
  Object.keys(_modules).forEach((key) => {
    const defaultModule = _modules[key].default;
    if (!defaultModule) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

// 使用手动导入的方式定义路由
export const appRoutes: AppRouteRecordRaw[] = [
  DASHBOARD,
  MONITOR_SCREEN,
  VISUALIZATION,
  LIST,
  FORM,
  PROFILE,
  RESULT,
  EXCEPTION,
  USER,
  MEMBER,
  SYSTEM,
  STATION,
  CHARGING,
  MARKETING,
  PARTNER,
  ORDER,
  PROFIT,
  BILLING,
  OCCUPANCY_FEE,
  HOMEPAGE,
  MEMBERCARD,
  INVOICE,
  STATISTIC,
  THIRD_PARTY,
  PARKING_WAIVER,
  BARRIER_DEVICE,
  PUBLIC_QRCODE,
  PAYMENT,
  INVESTOR,
  PARTNER_SETTLEMENT,
  CAR,
  FORWARD,
];

export const appExternalRoutes: RouteRecordNormalized[] = formatModules(
  externalModules,
  []
);
